import { getGPUTier, TierResult } from "detect-gpu";

//@ts-ignore
import DiskStorage from "disk-storage/disk-storage";
import { hasLocalStorage, storageNameSpace } from "./storage";

const expiry = 60 * 60 * 24 * 7;

export enum GPULevel {
  HIGH = "HIGH",
  LOW = "LOW",
}

export namespace GPULevelUtil {
  /**
   * Gets the GPULevel, either from override string, local storage or
   * benchmark
   * @param gpuTierOverrideStr from url
   * @returns GPULevel
   */
  export async function get(gpuTierOverrideStr?: string): Promise<GPULevel> {
    const gpuLevelOverride = fromString(gpuTierOverrideStr);

    let gpuLevel: GPULevel =
      gpuLevelOverride != undefined
        ? gpuLevelOverride
        : hasLocalStorage
        ? DiskStorage.get(storageNameSpace, "gpuLevel").value
        : undefined;

    if (gpuLevel) {
      console.log(
        `${gpuLevelOverride ? "overrode" : "loaded"} gpu level: ${gpuLevel}`
      );
    } else {
      const results = await getGPUTier();
      gpuLevel = fromTierResult(results);
      console.log(`benchmarked gpu level: ${gpuLevel}`);

      // cache result in local storage with 1 week's expiry
      DiskStorage.put(storageNameSpace, "gpuLevel", gpuLevel, expiry);
    }

    return gpuLevel;
  }

  /**
   * Sets the GPULevel in the cache for future runs - used as backstop if we
   * judge the benchmark to be incorrect
   * @param level
   * @param expires whether or not to expire this default
   */
  export function cache(level: GPULevel, expires = false) {
    DiskStorage.put(storageNameSpace, "gpuLevel", level, expires ? expiry : -1);
  }

  export function reset() {
    DiskStorage.delete(storageNameSpace, "gpuLevel");
  }

  function fromString(str?: string): GPULevel | undefined {
    const strUpper = str && str.toUpperCase();
    if (strUpper && Object.keys(GPULevel).includes(strUpper)) {
      return <GPULevel>strUpper;
    } else {
      return undefined;
    }
  }

  function fromTierResult(tier?: TierResult): GPULevel {
    const high = !!tier && (tier?.fps ? tier?.fps >= 45 : tier.tier >= 3);

    return high ? GPULevel.HIGH : GPULevel.LOW;
  }
}
